import assetLoader from '@utils/internalImageLoader'

export const OVERLAY_MODAL_DEFAULT_CROSS_ICON_SRC = `${assetLoader()}/images/crossIcon.svg`
